import React from 'react';
import {useFormContext} from 'react-hook-form';
const FormCheckbox = ({name, label, value, validate}) => {
  const {
    register,
  } = useFormContext();

  return (
    <div className="form-check">
      <input
        type="checkbox"
        id={`${name}-${value}`}
        value={value}
        className="form-check-input"
        {...register(name, validate)}
      />
      <label className="form-check-label" htmlFor={`${name}-${value}`}>
        {label}
      </label>
    </div>
  );
};

export default FormCheckbox;
